// AppSignal client init. Per PLAN.md addendum A2: stacktraces + route-transition
// breadcrumbs only. No per-click user-action tracking. No PII in error context.
//
// The AppSignal frontend key for the employee portal must be provisioned
// before going to production; in dev we skip init so nothing leaks.

import Appsignal from '@appsignal/javascript'
import { plugin as windowEventsPlugin } from '@appsignal/plugin-window-events'
import { isDev } from '~/utils/env'

const APPSIGNAL_KEY = 'cdd5dc60-610a-4b75-810d-f2bfb58b9f87'

let appsignal: Appsignal | null = null

if (typeof window !== 'undefined' && !isDev() && APPSIGNAL_KEY) {
  appsignal = new Appsignal({
    key: APPSIGNAL_KEY,
    revision: typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'unknown',
    // Suppressed app-wide: both uncaught errors and the ones we report ourselves.
    ignoreErrors: [
      /removeChild/,
      /not a child of this node/,
      /Failed to fetch dynamically imported module/,
      /Failed to fetch/,
      /Load failed/,
      // Browser notice, not a crash: the observer delivers the rest next frame.
      /ResizeObserver loop/,
    ],
  })

  appsignal.use(windowEventsPlugin())
}

export default appsignal
